export default __webpack_public_path__ + "graphics/wine.bf405285.jpg";